import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import {Card, CardActions, CardTitle, CardText} from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import {GridList, GridTile} from 'material-ui/GridList';
import ActionFavoriteBorder from 'material-ui/svg-icons/action/favorite-border';
import HomeGalleryHeader from './HomeGalleryHeader';
import HomeGalleryFooter from './HomeGalleryFooter';

import firebase from './firebase';

/* global braintree */
/* global emailjs */

class ArtworkDetailsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      artworkId: props.location.params.id,
      artwork: {
        thumbnail: "",
        title: "Loading...",
        size: "",
        year: "",
        price: "",
        artistId: "",
      },
      artistName: ""
    }

    this.artistRef = firebase.database().ref().child('art').child(this.state.artworkId);
    this.artistIdRef = this.artistRef.child('artistId');
  }

  componentDidMount() {
    this.artistRef.on('value', function(snapshot) {
      this.setState({artwork: snapshot.val()});
    }.bind(this));

    this.artistIdRef.on('value', function(snapshot) {
      var artistId = snapshot.val();
      this.artistNameRef = firebase.database().ref().child('artists').child(artistId).child('name');
      this.artistNameRef.on('value', function(artistNameSnapshot) {
        this.setState({artistName: artistNameSnapshot.val()});
      }.bind(this));
    }.bind(this));
  }

  componentWillUnmount() {
    if (this.artistRef != null) {
      this.artistRef.off();
    }
    if (this.artistIdRef != null) {
      this.artistIdRef.off();
    }
    if (this.artistNameRef != null) {
      this.artistNameRef.off();
    }
  }

  sendPurchaseInterestEmail(e) {
    e.preventDefault();

    var name = document.getElementById("user-name").value;
    var email = document.getElementById("user-email").value;
    console.log('sending email to ' + email);

    var emailSendError = document.getElementById("email-send-status");
    emailSendError.textContent = "Sending...";
    emailSendError.hidden = false;

    emailjs.send("mailgun", "purchase_interest", {
      email: email,
      name: name,
      artworkId: this.state.artworkId,
      artworkTitle: this.state.artwork.title,
      artistName: this.state.artistName,
    }).then(function(response) {
       console.log("SUCCESS. status=%d, text=%s", response.status, response.text);
       emailSendError.textContent = "Email sent. Check your inbox for more information. Thanks!";
       emailSendError.hidden = false;
    }, function(err) {
       console.log("FAILED. error=", err);
       emailSendError.textContent = "Sorry, something went wrong. Double check that you typed your email correctly and try again. If that doesn't work, reach out to andrew@homegalleryproject.com";
       emailSendError.hidden = false;
    });
  }

  showBuyDiv() {
    var buyDiv = document.getElementById("BuyDiv");
    buyDiv.hidden = false;
  }

  render() {
    return (
      <div>
        <HomeGalleryHeader />
        <div className="ArtworkDetailsPage" style={{width: "800px", margin: "auto"}}>
          <GridList className="ArtworkDetailsPageGrid" cellHeight="auto">
            <GridTile>
              <img alt="artwork" style={{width: "100%"}} className="ArtworkPhoto mdl-shadow--3dp" src={this.state.artwork.thumbnail} />
            </GridTile>
            <GridTile>
              <Card>
                <CardTitle style={{alignItems: 'flex-start'}} title={this.state.artwork.title} />
                <CardText>
                  <span className="ArtworkSize">{this.state.artwork.size}</span><br />
                  <span className="ArtistName">{this.state.artistName}</span><br />
                  <span className="ArtworkYear">{this.state.artwork.year}</span><br />
                  <span className="ArtworkPrice">{this.state.artwork.price}</span><br />
                </CardText>
                <CardActions style={{borderColor: 'rgba(0, 0, 0, 0.2)', display: 'flex', boxSizing: 'border-box', alignItems: 'center', color: '#fff'}}>
                  <FlatButton onClick={this.showBuyDiv.bind(this)}
                          primary={true}
                          label="Buy"
                          labelPosition="before"
                          icon={<ActionFavoriteBorder />}
                          className="PurchaseButton"
                          >
                  </FlatButton>
                </CardActions>
              </Card>
            </GridTile>
          </GridList>
          <div id="BuyDiv" hidden style={{textAlign: "center"}}>
            <h2>Buy "{this.state.artwork.title}"</h2>
            <div>
              Please enter your name and email so we can help you buy "{this.state.artwork.title}."<br />
              <TextField id="user-name" name="user-name" hintText="Name"></TextField><br />
              <TextField id="user-email" name="user-email" hintText="Email Address"></TextField><br />
              <div style={{display: "inline-block"}} className="g-recaptcha" data-sitekey="6LcnohIUAAAAAENaUTnvuL8xgy-U21TiudnpV7oC"></div><br />
              <p id="email-send-status" hidden></p>
              <RaisedButton style={{margin: "20px"}} primary={true} onClick={this.sendPurchaseInterestEmail.bind(this)}>Next</RaisedButton>
            </div>
          </div>
        </div>

        <div className="spacer" style={{marginBottom: "150px"}}></div>

        <HomeGalleryFooter />
    </div>
    );
  }
}

export default ArtworkDetailsPage;



// WEBPACK FOOTER //
// ./src/ArtworkDetailsPage.js